import { generateRawResponse } from "./chatUtils";
import { getRandomSuggestions } from './chatConstants';

const checkExactCommands = (input, setMessages, setInput) => {
    if (input.trim().toLowerCase() === 'telnet towel.blinkenlights.nl') {
        const userMessage = {
            id: Date.now() + Math.random(),
            sender: "user",
            text: input,
            displayText: input,
        };
        
        const telnetMessage = {
            id: Date.now() + Math.random() + 1,
            sender: "ai",
            text: {
                text: "Loading Star Wars ASCII Animation...",
                component: "TelnetFrame"
            },
            displayText: "",
        };
        
        setMessages(prev => [...prev, userMessage, telnetMessage]);
        setInput("");
        return true;
    }
    return false;
}

export const handleSubmit = (e, input, setInput, setMessages, setCurrentSuggestions, handleCommand, setIsChuckMode) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMessage = {
        id: Date.now() + Math.random(),
        sender: "user",
        text: input,
        displayText: input,
    };

    if (input.startsWith('/')) {
        if (handleCommand(input, setMessages, setIsChuckMode)) {
            setInput('');
            return;
        }
    }

    if (checkExactCommands(input, setMessages, setInput)) {
        return;
    }

    setMessages((prev) => [...prev, userMessage]);
    setInput("");
    setCurrentSuggestions(getRandomSuggestions());

    const rawResponse = generateRawResponse(input.trim());
    const aiMessage = {
        id: Date.now() + Math.random(),
        sender: "ai",
        text: rawResponse,
        displayText: "",
    };
    setMessages((prev) => [...prev, aiMessage]);
};

export const handleSuggestionClick = (suggestion, setMessages, setInput, setCurrentSuggestions) => {
    const userMessage = {
        id: Date.now() + Math.random(),
        sender: "user",
        text: suggestion,
        displayText: suggestion,
    };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");
    setCurrentSuggestions(getRandomSuggestions());

    const rawResponse = generateRawResponse(suggestion.trim());
    const aiMessage = {
        id: Date.now() + Math.random(),
        sender: "ai",
        text: rawResponse,
        displayText: "",
    };
    setMessages((prev) => [...prev, aiMessage]);
};

export const simulateTyping = (msgId, message, setMessages, setIsTyping, typingIntervalRef) => {
    if (!message) {
        console.error('Invalid message received in simulateTyping');
        return;
    }

    const fullText = typeof message === 'string' ? message : message.text;
    if (typeof fullText !== 'string') {
        console.error('Invalid message text received in simulateTyping');
        return;
    }

    setIsTyping(true);
    let index = 0;
    typingIntervalRef.current = setInterval(() => {
        setMessages((prev) => {
            return prev.map((m) => {
                if (m.id === msgId) {
                    return {
                        ...m,
                        displayText: fullText.slice(0, index + 1),
                        component: typeof message === 'object' ? message.component : undefined
                    };
                }
                return m;
            });
        });
        index++;
        if (index === fullText.length) {
            clearInterval(typingIntervalRef.current);
            setIsTyping(false);
        }
    }, 25);
};

export const skipTyping = (messages, typingIntervalRef, setMessages, setIsTyping) => {
    if (typingIntervalRef.current) {
        clearInterval(typingIntervalRef.current);
        const lastMessage = messages[messages.length - 1];
        if (lastMessage && lastMessage.sender === "ai") {
            setMessages(prev => prev.map(m => {
                if (m.id === lastMessage.id) {
                    return {
                        ...m,
                        displayText: typeof m.text === 'object' ? m.text.text : m.text,
                        component: typeof m.text === 'object' ? m.text.component : undefined
                    };
                }
                return m;
            }));
        }
        setIsTyping(false);
    }
};

export const clearChat = (welcomeMessage, setMessages) => {
    setMessages([welcomeMessage]);
};

export const handleNameEdit = (setIsEditingName, nameInputRef) => {
    setIsEditingName(true);
    setTimeout(() => nameInputRef.current?.focus(), 0);
};

export const handleNameSubmit = (e, nameInputRef, setVisitorName, setIsEditingName) => {
    e.preventDefault();
    const newName = nameInputRef.current?.value.trim();
    if (newName) {
        setVisitorName(newName);
    }
    setIsEditingName(false);
};